<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-sliders"></i></div>
      <div>
        Paramètre général
        <div class="page-title-subheading">Gestion des paramètres généraux</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="container">
        <div class="card">
            <div class="card-body">
                <div class=" form-group col-12 mb-3">
                    <label for="">Payer les salaires chaque (mois):</label>
                    <input type="number" min="1" max="31" name="name" class="form-control" ngModel>
                 </div>
            </div>
        </div>
    </div>